import { render, staticRenderFns } from "./InformativaRegistrazioneFarmacisti.vue?vue&type=template&id=72b14150&"
import script from "./InformativaRegistrazioneFarmacisti.vue?vue&type=script&lang=js&"
export * from "./InformativaRegistrazioneFarmacisti.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports